import { createSlice } from "@reduxjs/toolkit";
import { AppDataModel } from "@/features/auth";
import loginApi from "@/features/auth/api/login";

const initialState = {
  appData: {},
} as AppDataState;

const slice = createSlice({
  name: "appData",
  initialState,
  reducers: {
    setAppData: (state, { payload }: { payload: AppDataModel }) => {
      return { ...state, appData: payload };
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      loginApi.endpoints.getAppData.matchFulfilled,
      (state, { payload }: { payload: AppDataModel }) => {
        return { ...state, appData: payload };
      }
    );
  },
});

export const appData = slice.reducer;

export interface AppDataState {
  appData: AppDataModel;
}
